const MAC_POLICY_SET_ID = '3';
const WINDOWS_POLICY_SET_ID = '1';
const LINUX_POLICY_SET_ID = '2';
const PRINTER_ID = '4';
const ROUTER_ID = '5';
const SWITCH_ID = '6';
const FIREWALL_ID = '7';
const ANDROID_ID = '41';
const APPLE_IOS_ID = '42';
const APPLE_IPAD_OS_ID = '43';

function getAssetTabIconName(classId) {
  const classObj = {
    [WINDOWS_POLICY_SET_ID]: 'ASSET_WINDOWS',
    [MAC_POLICY_SET_ID]: 'ASSET_MAC',
    [LINUX_POLICY_SET_ID]: 'ASSET_LINUX',
    [PRINTER_ID]: 'ASSET_PRINTER',
    [ROUTER_ID]: 'ASSET_ROUTER',
    [SWITCH_ID]: 'ASSET_SWITCH',
    [FIREWALL_ID]: 'ASSET_FIREWALL',
    [ANDROID_ID]: 'ASSET_ANDROID',
    [APPLE_IOS_ID]: 'ASSET_APPLE_IOS',
    [APPLE_IPAD_OS_ID]: 'ASSET_APPLE_IPAD_OS'
  };
  return classObj[classId] || 'NON_MONITOR_ASSET';
}
export {
  MAC_POLICY_SET_ID,
  WINDOWS_POLICY_SET_ID,
  LINUX_POLICY_SET_ID,
  PRINTER_ID,
  getAssetTabIconName,
  ROUTER_ID,
  SWITCH_ID,
  FIREWALL_ID,
  ANDROID_ID,
  APPLE_IOS_ID,
  APPLE_IPAD_OS_ID
};
